import { ComponentProps } from 'react'

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

import { cx } from '@/lib/cva-config'

function AuthCardRoot({ className, ...rest }: ComponentProps<typeof Card>) {
  return (
    <Card
      className={cx(
        'w-full max-w-xl rounded-xl border-none bg-white bg-opacity-30 shadow-[0px_4px_30px_0px_#017EB71A] backdrop-blur',
        className
      )}
      {...rest}
    />
  )
}

function AuthCardTitle({
  className,
  ...rest
}: ComponentProps<typeof CardTitle>) {
  return (
    <CardTitle className={cx('text-2xl tracking-wide', className)} {...rest} />
  )
}

function AuthCardSubtitle({ className, ...rest }: ComponentProps<'h3'>) {
  return <h3 className={cx('font-semibold', className)} {...rest} />
}

function AuthCardContent({
  className,
  ...rest
}: ComponentProps<typeof CardContent>) {
  return <CardContent className={cx('grid gap-4', className)} {...rest} />
}

export const AuthCard = Object.assign(AuthCardRoot, {
  Header: CardHeader,
  Title: AuthCardTitle,
  Subtitle: AuthCardSubtitle,
  Content: AuthCardContent,
  Footer: CardFooter,
})
